// components/TercihRobotu.tsx
import React, { useState, useEffect } from 'react';
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    useTheme,
    useMediaQuery,
    Typography,
    CircularProgress,
    Alert,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    SelectChangeEvent,
    styled,
    Grid,
    Card,
    CardContent,
    TextField,
    Button,
    Chip,
    Divider,
    Slider,
    Autocomplete,
    Pagination,
    IconButton,
    Tooltip,
    Switch,
    FormControlLabel,
    Collapse,
    Stack
} from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import {
    getYokAtlasTercihRobotu,
    YokAtlasProgram,
    YokAtlasTercihRobotuRequestParams
} from '../services/api/yokAtlasService';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import SchoolIcon from '@mui/icons-material/School';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import InfoIcon from '@mui/icons-material/Info';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import ClearIcon from '@mui/icons-material/Clear';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import ScoreIcon from '@mui/icons-material/Score';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';

// Türkiye'deki şehirler
const turkiyeSehirleri = [
    'ADANA', 'ADIYAMAN', 'AFYONKARAHİSAR', 'AĞRI', 'AKSARAY', 'AMASYA', 'ANKARA', 'ANTALYA',
    'ARDAHAN', 'ARTVİN', 'AYDIN', 'BALIKESİR', 'BARTIN', 'BATMAN', 'BAYBURT', 'BİLECİK',
    'BİNGÖL', 'BİTLİS', 'BOLU', 'BURDUR', 'BURSA', 'ÇANAKKALE', 'ÇANKIRI', 'ÇORUM',
    'DENİZLİ', 'DİYARBAKIR', 'DÜZCE', 'EDİRNE', 'ELAZIĞ', 'ERZİNCAN', 'ERZURUM', 'ESKİŞEHİR',
    'GAZİANTEP', 'GİRESUN', 'GÜMÜŞHANE', 'HAKKARİ', 'HATAY', 'IĞDIR', 'ISPARTA', 'İSTANBUL',
    'İZMİR', 'KAHRAMANMARAŞ', 'KARABÜK', 'KARAMAN', 'KARS', 'KASTAMONU', 'KAYSERİ', 'KIRIKKALE',
    'KIRKLARELİ', 'KIRŞEHİR', 'KİLİS', 'KOCAELİ', 'KONYA', 'KÜTAHYA', 'MALATYA', 'MANİSA',
    'MARDİN', 'MERSİN', 'MUĞLA', 'MUŞ', 'NEVŞEHİR', 'NİĞDE', 'ORDU', 'OSMANİYE', 'RİZE',
    'SAKARYA', 'SAMSUN', 'SİİRT', 'SİNOP', 'SİVAS', 'ŞANLIURFA', 'ŞIRNAK', 'TEKİRDAĞ',
    'TOKAT', 'TRABZON', 'TUNCELİ', 'UŞAK', 'VAN', 'YALOVA', 'YOZGAT', 'ZONGULDAK'
];

// Önlisans programları listesi (YÖK Atlas'tan alınan verilere göre)
const onlisansProgramlari = [
    'Acil Durum ve Afet Yönetimi', 'Acil Durum ve Afet Yönetimi (Açıköğretim)', 'Açık Deniz Sondaj Teknolojisi',
    'Açık Deniz Tabanı Uygulamaları Teknolojisi', 'Ağız ve Diş Sağlığı', 'Akıllı Altyapılar Teknikerliği',
    'Akıllı Sera Teknolojileri', 'Akıllı Tarım ve Gıda Yönetimi', 'Alternatif Enerji Kaynakları Teknolojisi',
    'Ambalaj Tasarımı', 'Ameliyathane Hizmetleri', 'Anestezi', 'Arıcılık', 'Arka-Yüz Yazılım Geliştirme',
    'Aşçılık', 'Aşçılık (Açıköğretim)', 'Atçılık ve Antrenörlüğü', 'Avcılık ve Yaban Hayatı',
    'Ayakkabı Tasarım ve Üretimi', 'Bağcılık', 'Bağcılık ve Bağ Ürünleri Teknolojisi', 'Bahçe Tarımı',
    'Bankacılık ve Sigortacılık', 'Bankacılık ve Sigortacılık (Açıköğretim)', 'Basım ve Yayım Teknolojileri',
    'Bıçakçılık ve El Aletleri Üretim Teknolojisi', 'Bilgisayar Destekli Tasarım ve Animasyon',
    'Bilgisayar Operatörlüğü', 'Bilgisayar Programcılığı', 'Bilgisayar Programcılığı (Açıköğretim)',
    'Bilgisayar Teknolojisi', 'Bilişim Güvenliği Teknolojisi', 'Bitki Koruma', 'Biyokimya',
    'Biyomedikal Cihaz Teknolojisi', 'Boya Teknolojisi', 'Bulut Bilişim Operatörlüğü',
    'Büro Yönetimi ve Yönetici Asistanlığı', 'Büro Yönetimi ve Yönetici Asistanlığı (Açıköğretim)',
    'Büyük Veri Analistliği', 'Ceza İnfaz ve Güvenlik Hizmetleri', 'Cnc Programlama ve Operatörlüğü',
    'Coğrafi Bilgi Sistemleri', 'Coğrafi Bilgi Sistemleri (Açıköğretim)', 'Çağrı Merkezi Hizmetleri',
    'Çağrı Merkezi Hizmetleri (Açıköğretim)', 'Çay Tarımı ve İşleme Teknolojisi', 'Çevre Koruma ve Kontrol',
    'Çevre Sağlığı', 'Çevre Sağlığı ve Çevresel Risk Yönetimi Teknikerliği',
    'Çevresel Ölçüm ve İzleme Sistemleri Teknikerliği', 'Çim Alan Tesisi ve Yönetimi',
    'Çini Sanatı ve Tasarımı', 'Çocuk Gelişimi', 'Çocuk Koruma ve Bakım Hizmetleri',
    'Çok Boyutlu Modelleme ve Animasyon', 'Deniz Brokerliği', 'Deniz Ulaştırma ve İşletme',
    'Deniz ve Liman İşletmeciliği', 'Deri Teknolojisi', 'Dezenfeksiyon, Sterilizasyon ve Antisepsi Teknikerliği',
    'Dış Ticaret', 'Dış Ticaret (Açıköğretim)', 'Dijital Dönüşüm Elektroniği', 'Dijital Fabrika Teknolojileri',
    'Dijital Sağlık Sistemleri Teknikerliği', 'Dijital Tarım Teknolojileri', 'Diş Protez Teknolojisi',
    'Diyaliz', 'Doğal Yapı Taşları Teknolojisi', 'Doğalgaz ve Tesisatı Teknolojisi', 'Döküm',
    'E-Ticaret ve Pazarlama', 'E-Ticaret ve Pazarlama (Açıköğretim)', 'Eczane Hizmetleri', 'Elektrik',
    'Elektrik Enerjisi Üretim, İletim ve Dağıtımı', 'Elektrik Makineleri Bakım ve Onarımı',
    'Elektrikli Cihaz Teknolojisi', 'Elektronik Haberleşme Teknolojisi', 'Elektronik Teknolojisi',
    'Elektronörofizyoloji', 'Emlak Yönetimi', 'Emlak Yönetimi (Açıköğretim)', 'Endüstri Ürünleri Tasarımı',
    'Endüstriyel Cam ve Seramik', 'Endüstriyel Hammaddeler İşleme Teknolojisi', 'Endüstriyel Kalıpçılık',
    'Enerji Tesisleri İşletmeciliği', 'Engelli Bakımı ve Rehabilitasyon',
    'Engelli Bakımı ve Rehabilitasyon (Açıköğretim)', 'Engelliler İçin Gölge Öğreticilik', 'Eser Koruma',
    'Et ve Ürünleri Teknolojisi', 'Evde Hasta Bakımı', 'Fındık Eksperliği',
    'Fiber Tekne İmalatı ve Kompozit Kalıp Teknolojileri', 'Fidan Yetiştiriciliği', 'Fizyoterapi',
    'Fotoğrafçılık ve Kameramanlık', 'Fotoğrafçılık ve Kameramanlık (Açıköğretim)', 'Geleneksel El Sanatları',
    'Geleneksel Tekstillerin Korunması ve Restorasyonu', 'Gemi İnşaatı', 'Gemi Makineleri İşletmeciliği',
    'Geoteknik', 'Gıda Kalite Kontrolü ve Analizi', 'Gıda Teknolojisi', 'Giyim Üretim Teknolojisi',
    'Görsel İletişim', 'Grafik Tasarımı', 'Grafik Tasarımı (Açıköğretim)', 'Halıcılık ve Kilimcilik',
    'Halkla İlişkiler ve Tanıtım', 'Halkla İlişkiler ve Tanıtım (Açıköğretim)', 'Harita ve Kadastro',
    'Hasta Bakımı', 'Hava Aracı İmalat Teknolojileri', 'Hava Lojistiği', 'Havacılık Elektroniği Teknolojileri',
    'Hibrid ve Elektrikli Taşıtlar Teknolojisi', 'Hidrojen ve Enerji Depolama Teknikerliği',
    'Hidrolik ve Pnömatik Teknikerliği', 'İç Mekan Tasarımı', 'İklimlendirme ve Soğutma Teknolojisi',
    'İkram Hizmetleri', 'İlahiyat (Açıköğretim)', 'İlk ve Acil Yardım', 'İmalat Yürütme Sistemleri Operatörlüğü',
    'İnsan Kaynakları Yönetimi', 'İnsan Kaynakları Yönetimi (Açıköğretim)', 'İnsansız Araç Teknikerliği',
    'İnsansız Hava Aracı Teknolojisi ve Operatörlüğü', 'İnşaat Teknolojisi', 'İnternet ve Ağ Teknolojileri',
    'İslami İlimler (Açıköğretim)', 'İş Makineleri Operatörlüğü', 'İş Sağlığı ve Güvenliği',
    'İş Sağlığı ve Güvenliği (Açıköğretim)', 'İş ve Uğraşı Terapisi', 'İşletme Yönetimi',
    'İşletme Yönetimi (Açıköğretim)', 'Karayolu Yük Taşıtı Sürücülüğü', 'Karbon Yönetimi Teknikerliği',
    'Kaynak Teknolojisi', 'Kenevir Dokumacılığı', 'Kimya Teknolojisi', 'Kontrol ve Otomasyon Teknolojisi',
    'Kooperatifçilik', 'Kozmetik Teknolojisi', 'Kurumsal Bilişim Uzmanlığı', 'Kuyumculuk ve Takı Tasarımı',
    'Kültürel Miras ve Turizm', 'Kültürel Miras ve Turizm (Açıköğretim)', 'Kümes Hayvanları Yetiştiriciliği',
    'Laborant ve Veteriner Sağlık', 'Laboratuvar Teknolojisi', 'Lojistik', 'Lojistik (Açıköğretim)',
    'Madencilik Teknolojisi', 'Mahkeme Büro Hizmetleri', 'Makine', 'Makine Resim ve Konstrüksiyonu',
    'Maliye', 'Mantarcılık', 'Marina ve Yat İşletmeciliği', 'Marka İletişimi (Açıköğretim)',
    'Medya ve İletişim', 'Medya ve İletişim (Açıköğretim)', 'Mekatronik', 'Mermer Teknolojisi',
    'Metalurji', 'Meyve ve Sebze İşleme Teknolojisi', 'Mimari Dekoratif Sanatlar', 'Mimari Restorasyon',
    'Mobil Teknolojileri', 'Mobilya ve Dekorasyon', 'Moda Tasarımı', 'Moda Yönetimi',
    'Muhasebe ve Vergi Uygulamaları', 'Muhasebe ve Vergi Uygulamaları (Açıköğretim)',
    'Nükleer Teknoloji ve Radyasyon Güvenliği', 'Nükleer Tıp Teknikleri', 'Odyometri',
    'Ofis Teknolojileri ve Veri Yönetimi', 'Optisyenlik', 'Optoelektronik ve Elektro Optik Teknolojileri',
    'Organik Tarım', 'Ormancılık ve Orman Ürünleri', 'Ortopedik Protez ve Ortez', 'Otobüs Kaptanlığı',
    'Otomotiv Gövde ve Yüzey İşlem Teknolojileri', 'Otomotiv Teknolojisi', 'Otonom Sistemler Teknikerliği',
    'Otopsi Yardımcılığı', 'Oyun Geliştirme ve Programlama', 'Ön-Yüz Yazılım Geliştirme',
    'Özel Güvenlik ve Koruma', 'Pastacılık ve Ekmekçilik', 'Patoloji Laboratuvar Teknikleri',
    'Pazarlama', 'Perakende Satış ve Mağaza Yönetimi', 'Peyzaj ve Süs Bitkileri Yetiştiriciliği',
    'Podoloji', 'Polimer Teknolojisi', 'Posta Hizmetleri', 'Radyo ve Televizyon Teknolojisi',
    'Radyoterapi', 'Rafineri ve Petro-Kimya Teknolojisi', 'Raylı Sistemler Elektrik ve Elektronik',
    'Raylı Sistemler İşletmeciliği', 'Raylı Sistemler Makine Teknolojisi', 'Raylı Sistemler Makinistliği',
    'Raylı Sistemler Yol Teknolojisi', 'Reklamcılık', 'Reklamcılık (Açıköğretim)', 'Robotik ve Yapay Zeka',
    'Saç Bakımı ve Güzellik Hizmetleri', 'Sağlık Bilgi Sistemleri Teknikerliği', 'Sağlık Kurumları İşletmeciliği',
    'Sağlık Kurumları İşletmeciliği (Açıköğretim)', 'Sağlık Turizmi İşletmeciliği', 'Sahne Işık ve Ses Teknolojileri',
    'Sahne ve Dekor Tasarımı', 'Sanal ve Artırılmış Gerçeklik', 'Seracılık', 'Seramik ve Cam Tasarımı',
    'Siber Güvenlik', 'Siber Güvenlik Analistliği ve Operatörlüğü', 'Silah Sanayi Teknikerliği',
    'Sivil Hava Ulaştırma İşletmeciliği', 'Sivil Hava Ulaştırma İşletmeciliği (Açıköğretim)',
    'Sivil Havacılık Kabin Hizmetleri', 'Sivil Savunma ve İtfaiyecilik', 'Sondaj Teknolojisi',
    'Sosyal Güvenlik', 'Sosyal Hizmetler', 'Sosyal Hizmetler (Açıköğretim)', 'Sosyal Medya Yöneticiliği (Açıköğretim)',
    'Su Altı Kaynak Teknolojisi', 'Su Altı Teknolojisi', 'Su Ürünleri İşleme Teknolojisi',
    'Su ve Atık Yönetimi Teknikerliği', 'Sulama Teknolojisi', 'Süt ve Besi Hayvancılığı',
    'Süt ve Ürünleri Teknolojisi', 'Şarap Üretim Teknolojisi', 'Tahribatsız Muayene',
    'Talaşlı Üretim Teknikerliği', 'Tapu ve Kadastro', 'Tarım Makineleri', 'Tarım Makineleri ve Teknolojileri',
    'Tarım Teknolojisi (Açıköğretim)', 'Tarımsal İşletmecilik', 'Tarla Bitkileri', 'Tekstil Teknolojisi',
    'Tekstil ve Halı Makineleri', 'Tele-Sağlık Teknikerliği', 'Tıbbi Dokümantasyon ve Sekreterlik',
    'Tıbbi Dokümantasyon ve Sekreterlik (Açıköğretim)', 'Tıbbi Görüntüleme Teknikleri',
    'Tıbbi Laboratuvar Teknikleri', 'Tıbbi Tanıtım ve Pazarlama', 'Tıbbi ve Aromatik Bitkiler',
    'Tıbbi Veri İşleme Teknikerliği', 'Tohumculuk Teknolojisi', 'Turist Rehberliği', 'Turizm Animasyonu',
    'Turizm ve Otel İşletmeciliği', 'Turizm ve Otel İşletmeciliği (Açıköğretim)', 'Turizm ve Seyahat Hizmetleri',
    'Uçak Teknolojisi', 'Uçuş Harekat Yöneticiliği', 'Ulaştırma ve Trafik Hizmetleri',
    'Un ve Unlu Mamuller Teknolojisi', 'Uzaktan Algılama ve Coğrafi Bilgi Sistemleri', 'Üretimde Kalite Kontrol',
    'Web Tasarımı ve Kodlama', 'Web Tasarımı ve Kodlama (Açıköğretim)', 'Yağ Endüstrisi',
    'Yapay Zeka Operatörlüğü', 'Yapı Denetimi', 'Yapı Ressamlığı', 'Yapı Tesisat Teknolojisi',
    'Yapı Yalıtım Teknolojisi', 'Yapı Yüzeyi Tasarım Teknikerliği', 'Yaşlı Bakımı', 'Yaşlı Bakımı (Açıköğretim)',
    'Yat Kaptanlığı', 'Yeni Medya ve Gazetecilik (Açıköğretim)', 'Yenilenebilir Enerji Teknikerliği',
    'Yerel Yönetimler', 'Yerel Yönetimler (Açıköğretim)', 'Yeşil ve Ekolojik Bina Teknikerliği',
    'Zeytincilik ve Zeytin İşleme Teknolojisi'
];

// Üniversiteler listesi (YÖK Atlas'tan alınan verilere göre)
const universiteler = [
    'ACIBADEM MEHMET ALİ AYDINLAR ÜNİVERSİTESİ', 'ADANA ALPARSLAN TÜRKEŞ BİLİM VE TEKNOLOJİ ÜNİVERSİTESİ',
    'ADIYAMAN ÜNİVERSİTESİ', 'AFYON KOCATEPE ÜNİVERSİTESİ', 'AFYONKARAHİSAR SAĞLIK BİLİMLERİ ÜNİVERSİTESİ',
    'AĞRI İBRAHİM ÇEÇEN ÜNİVERSİTESİ', 'AKDENİZ KARPAZ ÜNİVERSİTESİ', 'AKDENİZ ÜNİVERSİTESİ',
    'AKSARAY ÜNİVERSİTESİ', 'ALANYA ALAADDİN KEYKUBAT ÜNİVERSİTESİ', 'ALANYA ÜNİVERSİTESİ',
    'ALTINBAŞ ÜNİVERSİTESİ', 'AMASYA ÜNİVERSİTESİ', 'ANADOLU ÜNİVERSİTESİ', 'ANKARA BİLİM ÜNİVERSİTESİ',
    'ANKARA HACI BAYRAM VELİ ÜNİVERSİTESİ', 'ANKARA MEDİPOL ÜNİVERSİTESİ', 'ANKARA MÜZİK VE GÜZEL SANATLAR ÜNİVERSİTESİ',
    'ANKARA SOSYAL BİLİMLER ÜNİVERSİTESİ', 'ANKARA ÜNİVERSİTESİ', 'ANKARA YILDIRIM BEYAZIT ÜNİVERSİTESİ',
    'ANTALYA BELEK ÜNİVERSİTESİ', 'ANTALYA BİLİM ÜNİVERSİTESİ', 'ARDAHAN ÜNİVERSİTESİ',
    'ARTVİN ÇORUH ÜNİVERSİTESİ', 'ATAŞEHİR ADIGÜZEL MESLEK YÜKSEKOKULU', 'ATATÜRK ÜNİVERSİTESİ',
    'ATILIM ÜNİVERSİTESİ', 'AVRASYA ÜNİVERSİTESİ', 'AYDIN ADNAN MENDERES ÜNİVERSİTESİ',
    'BAHÇEŞEHİR ÜNİVERSİTESİ', 'BALIKESİR ÜNİVERSİTESİ', 'BANDIRMA ONYEDİ EYLÜL ÜNİVERSİTESİ',
    'BARTIN ÜNİVERSİTESİ', 'BAŞKENT ÜNİVERSİTESİ', 'BATMAN ÜNİVERSİTESİ', 'BAYBURT ÜNİVERSİTESİ',
    'BEYKOZ ÜNİVERSİTESİ', 'BEZM-İ ÂLEM VAKIF ÜNİVERSİTESİ', 'BİLECİK ŞEYH EDEBALİ ÜNİVERSİTESİ',
    'BİNGÖL ÜNİVERSİTESİ', 'BİRUNİ ÜNİVERSİTESİ', 'BİTLİS EREN ÜNİVERSİTESİ',
    'BOLU ABANT İZZET BAYSAL ÜNİVERSİTESİ', 'BURDUR MEHMET AKİF ERSOY ÜNİVERSİTESİ',
    'BURSA ULUDAĞ ÜNİVERSİTESİ', 'ÇAĞ ÜNİVERSİTESİ', 'ÇANAKKALE ONSEKİZ MART ÜNİVERSİTESİ',
    'ÇANKAYA ÜNİVERSİTESİ', 'ÇANKIRI KARATEKİN ÜNİVERSİTESİ', 'ÇUKUROVA ÜNİVERSİTESİ',
    'DEMİROĞLU BİLİM ÜNİVERSİTESİ', 'DİCLE ÜNİVERSİTESİ', 'DOĞU AKDENİZ ÜNİVERSİTESİ',
    'DOĞUŞ ÜNİVERSİTESİ', 'DOKUZ EYLÜL ÜNİVERSİTESİ', 'DÜZCE ÜNİVERSİTESİ', 'EGE ÜNİVERSİTESİ',
    'ERCİYES ÜNİVERSİTESİ', 'ERZİNCAN BİNALİ YILDIRIM ÜNİVERSİTESİ', 'ESKİŞEHİR OSMANGAZİ ÜNİVERSİTESİ',
    'ESKİŞEHİR TEKNİK ÜNİVERSİTESİ', 'FATİH SULTAN MEHMET VAKIF ÜNİVERSİTESİ', 'FENERBAHÇE ÜNİVERSİTESİ',
    'FIRAT ÜNİVERSİTESİ', 'GALATASARAY ÜNİVERSİTESİ', 'GAZİ ÜNİVERSİTESİ',
    'GAZİANTEP İSLAM BİLİM VE TEKNOLOJİ ÜNİVERSİTESİ', 'GAZİANTEP ÜNİVERSİTESİ',
    'GEBZE TEKNİK ÜNİVERSİTESİ', 'GİRESUN ÜNİVERSİTESİ', 'GİRNE AMERİKAN ÜNİVERSİTESİ',
    'GİRNE ÜNİVERSİTESİ', 'GÜMÜŞHANE ÜNİVERSİTESİ', 'HACETTEPE ÜNİVERSİTESİ',
    'HAKKARİ ÜNİVERSİTESİ', 'HALİÇ ÜNİVERSİTESİ', 'HARRAN ÜNİVERSİTESİ',
    'HASAN KALYONCU ÜNİVERSİTESİ', 'HATAY MUSTAFA KEMAL ÜNİVERSİTESİ', 'HİTİT ÜNİVERSİTESİ',
    'HOCA AHMET YESEVİ ULUSLARARASI TÜRK-KAZAK ÜNİVERSİTESİ', 'IĞDIR ÜNİVERSİTESİ',
    'ISPARTA UYGULAMALI BİLİMLER ÜNİVERSİTESİ', 'IŞIK ÜNİVERSİTESİ', 'İNÖNÜ ÜNİVERSİTESİ',
    'İSKENDERUN TEKNİK ÜNİVERSİTESİ', 'İSTANBUL 29 MAYIS ÜNİVERSİTESİ', 'İSTANBUL AREL ÜNİVERSİTESİ',
    'İSTANBUL ATLAS ÜNİVERSİTESİ', 'İSTANBUL AYDIN ÜNİVERSİTESİ', 'İSTANBUL BEYKENT ÜNİVERSİTESİ',
    'İSTANBUL BİLGİ ÜNİVERSİTESİ', 'İSTANBUL ESENYURT ÜNİVERSİTESİ', 'İSTANBUL GALATA ÜNİVERSİTESİ',
    'İSTANBUL GEDİK ÜNİVERSİTESİ', 'İSTANBUL GELİŞİM ÜNİVERSİTESİ', 'İSTANBUL KENT ÜNİVERSİTESİ',
    'İSTANBUL KÜLTÜR ÜNİVERSİTESİ', 'İSTANBUL MEDİPOL ÜNİVERSİTESİ', 'İSTANBUL NİŞANTAŞI ÜNİVERSİTESİ',
    'İSTANBUL OKAN ÜNİVERSİTESİ', 'İSTANBUL RUMELİ ÜNİVERSİTESİ', 'İSTANBUL SAĞLIK VE SOSYAL BİLİMLER MESLEK YÜKSEKOKULU',
    'İSTANBUL ŞİŞLİ MESLEK YÜKSEKOKULU', 'İSTANBUL TEKNİK ÜNİVERSİTESİ', 'İSTANBUL TİCARET ÜNİVERSİTESİ',
    'İSTANBUL TOPKAPI ÜNİVERSİTESİ', 'İSTANBUL ÜNİVERSİTESİ', 'İSTANBUL ÜNİVERSİTESİ-CERRAHPAŞA',
    'İSTANBUL YENİ YÜZYIL ÜNİVERSİTESİ', 'İSTİNYE ÜNİVERSİTESİ', 'İZMİR BAKIRÇAY ÜNİVERSİTESİ',
    'İZMİR DEMOKRASİ ÜNİVERSİTESİ', 'İZMİR EKONOMİ ÜNİVERSİTESİ', 'İZMİR KATİP ÇELEBİ ÜNİVERSİTESİ',
    'İZMİR KAVRAM MESLEK YÜKSEKOKULU', 'İZMİR TINAZTEPE ÜNİVERSİTESİ', 'KAFKAS ÜNİVERSİTESİ',
    'KAHRAMANMARAŞ İSTİKLAL ÜNİVERSİTESİ', 'KAHRAMANMARAŞ SÜTÇÜ İMAM ÜNİVERSİTESİ', 'KAPADOKYA ÜNİVERSİTESİ',
    'KARABÜK ÜNİVERSİTESİ', 'KARADENİZ TEKNİK ÜNİVERSİTESİ', 'KARAMANOĞLU MEHMETBEY ÜNİVERSİTESİ',
    'KASTAMONU ÜNİVERSİTESİ', 'KAYSERİ ÜNİVERSİTESİ', 'KIBRIS AMERİKAN ÜNİVERSİTESİ',
    'KIBRIS AYDIN ÜNİVERSİTESİ', 'KIBRIS SAĞLIK VE TOPLUM BİLİMLERİ ÜNİVERSİTESİ', 'KIRIKKALE ÜNİVERSİTESİ',
    'KIRKLARELİ ÜNİVERSİTESİ', 'KIRŞEHİR AHİ EVRAN ÜNİVERSİTESİ', 'KİLİS 7 ARALIK ÜNİVERSİTESİ',
    'KOCAELİ SAĞLIK VE TEKNOLOJİ ÜNİVERSİTESİ', 'KOCAELİ ÜNİVERSİTESİ', 'KONYA TEKNİK ÜNİVERSİTESİ',
    'KTO KARATAY ÜNİVERSİTESİ', 'KÜTAHYA DUMLUPINAR ÜNİVERSİTESİ', 'KÜTAHYA SAĞLIK BİLİMLERİ ÜNİVERSİTESİ',
    'LEFKE AVRUPA ÜNİVERSİTESİ', 'LOKMAN HEKİM ÜNİVERSİTESİ', 'MALATYA TURGUT ÖZAL ÜNİVERSİTESİ',
    'MALTEPE ÜNİVERSİTESİ', 'MANİSA CELÂL BAYAR ÜNİVERSİTESİ', 'MARDİN ARTUKLU ÜNİVERSİTESİ',
    'MARMARA ÜNİVERSİTESİ', 'MERSİN ÜNİVERSİTESİ', 'MİMAR SİNAN GÜZEL SANATLAR ÜNİVERSİTESİ',
    'MUDANYA ÜNİVERSİTESİ', 'MUĞLA SITKI KOÇMAN ÜNİVERSİTESİ', 'MUNZUR ÜNİVERSİTESİ',
    'MUŞ ALPARSLAN ÜNİVERSİTESİ', 'NECMETTİN ERBAKAN ÜNİVERSİTESİ', 'NEVŞEHİR HACI BEKTAŞ VELİ ÜNİVERSİTESİ',
    'NİĞDE ÖMER HALİSDEMİR ÜNİVERSİTESİ', 'NUH NACİ YAZGAN ÜNİVERSİTESİ', 'ONDOKUZ MAYIS ÜNİVERSİTESİ',
    'ORDU ÜNİVERSİTESİ', 'OSMANİYE KORKUT ATA ÜNİVERSİTESİ', 'OSTİM TEKNİK ÜNİVERSİTESİ',
    'PAMUKKALE ÜNİVERSİTESİ', 'PİRİ REİS ÜNİVERSİTESİ', 'RECEP TAYYİP ERDOĞAN ÜNİVERSİTESİ',
    'SAĞLIK BİLİMLERİ ÜNİVERSİTESİ', 'SAKARYA UYGULAMALI BİLİMLER ÜNİVERSİTESİ', 'SAKARYA ÜNİVERSİTESİ',
    'SAMSUN ÜNİVERSİTESİ', 'SANKO ÜNİVERSİTESİ', 'SELÇUK ÜNİVERSİTESİ', 'SİİRT ÜNİVERSİTESİ',
    'SİNOP ÜNİVERSİTESİ', 'SİVAS BİLİM VE TEKNOLOJİ ÜNİVERSİTESİ', 'SİVAS CUMHURİYET ÜNİVERSİTESİ',
    'SÜLEYMAN DEMİREL ÜNİVERSİTESİ', 'ŞIRNAK ÜNİVERSİTESİ', 'TARSUS ÜNİVERSİTESİ',
    'TEKİRDAĞ NAMIK KEMAL ÜNİVERSİTESİ', 'TOKAT GAZİOSMANPAŞA ÜNİVERSİTESİ', 'TOROS ÜNİVERSİTESİ',
    'TRABZON ÜNİVERSİTESİ', 'TRAKYA ÜNİVERSİTESİ', 'TÜRK HAVA KURUMU ÜNİVERSİTESİ', 'UFUK ÜNİVERSİTESİ',
    'ULUSLARARASI FİNAL ÜNİVERSİTESİ', 'ULUSLARARASI KIBRIS ÜNİVERSİTESİ', 'UŞAK ÜNİVERSİTESİ',
    'ÜSKÜDAR ÜNİVERSİTESİ', 'VAN YÜZÜNCÜ YIL ÜNİVERSİTESİ', 'YAKIN DOĞU ÜNİVERSİTESİ',
    'YALOVA ÜNİVERSİTESİ', 'YAŞAR ÜNİVERSİTESİ', 'YEDİTEPE ÜNİVERSİTESİ', 'YOZGAT BOZOK ÜNİVERSİTESİ',
    'YÜKSEK İHTİSAS ÜNİVERSİTESİ', 'ZONGULDAK BÜLENT ECEVİT ÜNİVERSİTESİ'
];

// Styled components
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    fontWeight: 'bold',
    padding: theme.spacing(1.5),
    [theme.breakpoints.down('md')]: {
        padding: theme.spacing(1),
    },
}));

const HeaderTableCell = styled(TableCell)(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: 'bold',
    padding: theme.spacing(1.5),
    [theme.breakpoints.down('md')]: {
        padding: theme.spacing(1),
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:hover': {
        backgroundColor: theme.palette.primary.light + '20',
        transition: 'background-color 0.3s ease',
    },
    transition: 'background-color 0.2s',
}));

const FilterCard = styled(Card)(({ theme }) => ({
    marginBottom: theme.spacing(3),
    borderRadius: theme.shape.borderRadius * 1.5,
    boxShadow: theme.shadows[2],
}));

const ProgramCard = styled(Card)(({ theme }) => ({
    height: '100%',
    transition: 'transform 0.3s, box-shadow 0.3s',
    cursor: 'pointer',
    '&:hover': {
        transform: 'translateY(-5px)',
        boxShadow: theme.shadows[6],
    },
}));

const TercihRobotu: React.FC = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.down("md"));

    // Filtre durumları
    const [showFilters, setShowFilters] = useState<boolean>(!isMobile);
    const [programTuru, setProgramTuru] = useState<'onlisans' | 'lisans'>('onlisans');
    const [puanTuru, setPuanTuru] = useState<string>('TYT');
    const [selectedUniversiteler, setSelectedUniversiteler] = useState<string[]>([]);
    const [selectedProgramlar, setSelectedProgramlar] = useState<string[]>([]);
    const [selectedSehirler, setSelectedSehirler] = useState<string[]>([]);
    const [universiteTuru, setUniversiteTuru] = useState<('devlet' | 'vakif' | 'kktc' | 'yurtdisi')[]>(['devlet', 'vakif']);
    const [ucretBurs, setUcretBurs] = useState<('ucretsiz' | 'ucretli' | 'io-ucretli' | 'burslu' | 'indirimli25' | 'indirimli50' | 'ao-ucretli' | 'uo-ucretli')[]>([]);
    const [ogretimTuru, setOgretimTuru] = useState<('orgun' | 'ikinci' | 'acik' | 'uzaktan')[]>([]);
    const [puanAraligi, setPuanAraligi] = useState<[number, number]>([150, 500]);
    const [programKodu, setProgramKodu] = useState<string>('');
    const [dolulukDurumu, setDolulukDurumu] = useState<boolean | null>(null);

    // Sayfalama
    const [page, setPage] = useState<number>(0);
    const [limit, setLimit] = useState<number>(20);

    // Favori programlar
    const [favoriler, setFavoriler] = useState<string[]>([]);
    const [sadeceFavoriler, setSadeceFavoriler] = useState<boolean>(false);

    // Karşılaştırma
    const [karsilastirma, setKarsilastirma] = useState<string[]>([]);
    const [showKarsilastirma, setShowKarsilastirma] = useState<boolean>(false);

    // Filtreleri uygula
    const applyFilters = (): YokAtlasTercihRobotuRequestParams => {
        return {
            programTuru,
            puanTuru,
            sehirler: selectedSehirler.length > 0 ? selectedSehirler : undefined,
            universiteTuru: universiteTuru.length > 0 ? universiteTuru.filter(ut => ut === 'devlet' || ut === 'vakif') as ('devlet' | 'vakif')[] : undefined,
            minPuan: puanAraligi[0],
            maxPuan: puanAraligi[1],
            bolumAdi: selectedProgramlar.length > 0 ? selectedProgramlar.join(',') : undefined,
            bursTuru: ucretBurs.length > 0 ? ucretBurs.filter(ub => ub === 'ucretli' || ub === 'burslu' || ub === 'indirimli25' || ub === 'indirimli50').map(ub => {
                if (ub === 'ucretli') return 'ucretli';
                if (ub === 'burslu') return 'burslu';
                if (ub === 'indirimli25' || ub === 'indirimli50') return 'indirimli';
                return 'ucretli';
            }) as ('ucretli' | 'burslu' | 'indirimli')[] : undefined,
            ogretimTuru: ogretimTuru.length > 0 ? ogretimTuru : undefined,
            dolulukDurumu: dolulukDurumu !== null ? (dolulukDurumu ? ['doldu'] : ['dolmadi']) : undefined,
            limit,
            page
        };
    };

    // Filtreleri sıfırla
    const resetFilters = () => {
        setProgramTuru('onlisans');
        setPuanTuru('TYT');
        setSelectedUniversiteler([]);
        setSelectedProgramlar([]);
        setSelectedSehirler([]);
        setUniversiteTuru(['devlet', 'vakif']);
        setUcretBurs([]);
        setOgretimTuru([]);
        setPuanAraligi([150, 500]);
        setProgramKodu('');
        setDolulukDurumu(null);
        setPage(0);
    };

    // Veri çekme işlemi
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["YokAtlasTercihRobotu", programTuru, puanTuru, selectedSehirler, universiteTuru, puanAraligi, selectedProgramlar, ucretBurs, ogretimTuru, dolulukDurumu, page, limit],
        queryFn: async () => {
            return await getYokAtlasTercihRobotu(applyFilters());
        },
        // keepPreviousData: true,
    });

    // Favorilere ekle/çıkar
    const toggleFavori = (programKodu: string) => {
        if (favoriler.includes(programKodu)) {
            setFavoriler(favoriler.filter(kod => kod !== programKodu));
        } else {
            setFavoriler([...favoriler, programKodu]);
        }
    };

    // Karşılaştırmaya ekle/çıkar
    const toggleKarsilastirma = (programKodu: string) => {
        if (karsilastirma.includes(programKodu)) {
            setKarsilastirma(karsilastirma.filter(kod => kod !== programKodu));
        } else {
            if (karsilastirma.length < 3) {
                setKarsilastirma([...karsilastirma, programKodu]);
            } else {
                alert('En fazla 3 program karşılaştırabilirsiniz!');
            }
        }
    };

    // Favorileri localStorage'a kaydet
    useEffect(() => {
        localStorage.setItem('tercihRobotuFavoriler', JSON.stringify(favoriler));
    }, [favoriler]);

    // Sayfa yüklendiğinde localStorage'dan favorileri al
    useEffect(() => {
        const storedFavoriler = localStorage.getItem('tercihRobotuFavoriler');
        if (storedFavoriler) {
            setFavoriler(JSON.parse(storedFavoriler));
        }
    }, []);

    // Filtrelenmiş programlar
    const filteredPrograms = React.useMemo(() => {
        if (!data) return [];

        if (sadeceFavoriler) {
            return data.data.filter(program => favoriler.includes(program.programKodu));
        }

        return data.data;
    }, [data, sadeceFavoriler, favoriler]);

    // Karşılaştırma programları
    const karsilastirmaPrograms = React.useMemo(() => {
        if (!data) return [];

        return data.data.filter(program => karsilastirma.includes(program.programKodu));
    }, [data, karsilastirma]);

    // Mobil kart görünümü
    const renderProgramCard = (program: YokAtlasProgram) => {
        return (
            <Grid item xs={12} sm={6} md={4} key={program.programKodu}>
                <ProgramCard elevation={3}>
                    <CardContent>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                            <Typography variant="h6" component="h2" gutterBottom>
                                {program.bolumAdi}
                            </Typography>
                            <Box>
                                <IconButton
                                    size="small"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleFavori(program.programKodu);
                                    }}
                                >
                                    {favoriler.includes(program.programKodu) ?
                                        <FavoriteIcon color="error" /> :
                                        <FavoriteBorderIcon />
                                    }
                                </IconButton>
                                <IconButton
                                    size="small"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleKarsilastirma(program.programKodu);
                                    }}
                                >
                                    {karsilastirma.includes(program.programKodu) ?
                                        <CompareArrowsIcon color="primary" /> :
                                        <CompareArrowsIcon />
                                    }
                                </IconButton>
                            </Box>
                        </Box>

                        <Chip
                            label={program.programKodu}
                            size="small"
                            color="primary"
                            sx={{ mb: 1 }}
                        />

                        <Typography variant="body2" color="text.secondary" gutterBottom>
                            <AccountBalanceIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1 }} />
                            {program.universiteAdi}
                        </Typography>

                        <Typography variant="body2" color="text.secondary" gutterBottom>
                            <LocationOnIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1 }} />
                            {program.sehir}
                        </Typography>

                        <Divider sx={{ my: 1.5 }} />

                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <Typography variant="body2" color="text.secondary">
                                    Puan:
                                </Typography>
                                <Typography variant="body1" fontWeight="bold">
                                    {program.taban.toFixed(2)}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" color="text.secondary">
                                    Sıralama:
                                </Typography>
                                <Typography variant="body1" fontWeight="bold">
                                    {program.siralama.toLocaleString()}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" color="text.secondary">
                                    Kontenjan:
                                </Typography>
                                <Typography variant="body1">
                                    {program.kontenjan}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" color="text.secondary">
                                    Doluluk:
                                </Typography>
                                <Chip
                                    label={program.doluluk}
                                    size="small"
                                    color={program.doluluk === "Doldu" ? "success" : "warning"}
                                />
                            </Grid>
                        </Grid>

                        <Divider sx={{ my: 1.5 }} />

                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                            <Chip
                                label={program.ucret}
                                size="small"
                                variant="outlined"
                                icon={program.ucret === "Ücretsiz" ? <MoneyOffIcon fontSize="small" /> : <AttachMoneyIcon fontSize="small" />}
                            />
                            <Chip
                                label={program.ogretimTuru}
                                size="small"
                                variant="outlined"
                                icon={<AccessTimeIcon fontSize="small" />}
                            />
                            {program.programTuru.includes("Burslu") && (
                                <Chip
                                    label="Burslu"
                                    size="small"
                                    variant="outlined"
                                    color="success"
                                    icon={<EmojiEventsIcon fontSize="small" />}
                                />
                            )}
                        </Box>

                        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                            <Button
                                variant="outlined"
                                size="small"
                                startIcon={<InfoIcon />}
                                href={program.detayUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Detaylar
                            </Button>
                        </Box>
                    </CardContent>
                </ProgramCard>
            </Grid>
        );
    };

    // Tablo görünümü
    const renderProgramTable = () => {
        return (
            <TableContainer component={Paper} elevation={3} sx={{ borderRadius: theme.shape.borderRadius * 1.5 }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <HeaderTableCell>Program Kodu</HeaderTableCell>
                            <HeaderTableCell>Üniversite</HeaderTableCell>
                            <HeaderTableCell>Program</HeaderTableCell>
                            <HeaderTableCell>Şehir</HeaderTableCell>
                            <HeaderTableCell>Puan</HeaderTableCell>
                            <HeaderTableCell>Sıralama</HeaderTableCell>
                            <HeaderTableCell>Kontenjan</HeaderTableCell>
                            <HeaderTableCell>Doluluk</HeaderTableCell>
                            <HeaderTableCell>Tür</HeaderTableCell>
                            <HeaderTableCell>İşlemler</HeaderTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredPrograms.map((program) => (
                            <StyledTableRow key={program.programKodu}>
                                <StyledTableCell>{program.programKodu}</StyledTableCell>
                                <StyledTableCell>{program.universiteAdi}</StyledTableCell>
                                <StyledTableCell>{program.bolumAdi}</StyledTableCell>
                                <StyledTableCell>{program.sehir}</StyledTableCell>
                                <StyledTableCell>{program.taban.toFixed(2)}</StyledTableCell>
                                <StyledTableCell>{program.siralama.toLocaleString()}</StyledTableCell>
                                <StyledTableCell>{program.kontenjan}</StyledTableCell>
                                <StyledTableCell>
                                    <Chip
                                        label={program.doluluk}
                                        size="small"
                                        color={program.doluluk === "Doldu" ? "success" : "warning"}
                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                        <Chip label={program.ucret} size="small" variant="outlined" />
                                        <Chip label={program.ogretimTuru} size="small" variant="outlined" />
                                        {program.programTuru.includes("Burslu") && (
                                            <Chip label="Burslu" size="small" variant="outlined" color="success" />
                                        )}
                                    </Box>
                                </StyledTableCell>
                                <StyledTableCell>
                                    <Box sx={{ display: 'flex', gap: 1 }}>
                                        <Tooltip title={favoriler.includes(program.programKodu) ? "Favorilerden Çıkar" : "Favorilere Ekle"}>
                                            <IconButton
                                                size="small"
                                                onClick={() => toggleFavori(program.programKodu)}
                                            >
                                                {favoriler.includes(program.programKodu) ?
                                                    <FavoriteIcon color="error" /> :
                                                    <FavoriteBorderIcon />
                                                }
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title={karsilastirma.includes(program.programKodu) ? "Karşılaştırmadan Çıkar" : "Karşılaştırmaya Ekle"}>
                                            <IconButton
                                                size="small"
                                                onClick={() => toggleKarsilastirma(program.programKodu)}
                                            >
                                                {karsilastirma.includes(program.programKodu) ?
                                                    <CompareArrowsIcon color="primary" /> :
                                                    <CompareArrowsIcon />
                                                }
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Detaylar">
                                            <IconButton
                                                size="small"
                                                component="a"
                                                href={program.detayUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <InfoIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    };

    // Karşılaştırma tablosu
    const renderKarsilastirmaTable = () => {
        if (karsilastirmaPrograms.length === 0) {
            return (
                <Alert severity="info" sx={{ mt: 2 }}>
                    Karşılaştırma için program seçilmedi. En fazla 3 program karşılaştırabilirsiniz.
                </Alert>
            );
        }

        return (
            <TableContainer component={Paper} elevation={3} sx={{ borderRadius: theme.shape.borderRadius * 1.5, mt: 2 }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <HeaderTableCell>Özellik</HeaderTableCell>
                            {karsilastirmaPrograms.map(program => (
                                <HeaderTableCell key={program.programKodu}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography variant="body2">{program.bolumAdi}</Typography>
                                        <IconButton
                                            size="small"
                                            onClick={() => toggleKarsilastirma(program.programKodu)}
                                            sx={{ color: 'white' }}
                                        >
                                            <ClearIcon fontSize="small" />
                                        </IconButton>
                                    </Box>
                                </HeaderTableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <StyledTableRow>
                            <StyledTableCell>Üniversite</StyledTableCell>
                            {karsilastirmaPrograms.map(program => (
                                <StyledTableCell key={`${program.programKodu}-uni`}>{program.universiteAdi}</StyledTableCell>
                            ))}
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableCell>Program Kodu</StyledTableCell>
                            {karsilastirmaPrograms.map(program => (
                                <StyledTableCell key={`${program.programKodu}-kod`}>{program.programKodu}</StyledTableCell>
                            ))}
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableCell>Şehir</StyledTableCell>
                            {karsilastirmaPrograms.map(program => (
                                <StyledTableCell key={`${program.programKodu}-sehir`}>{program.sehir}</StyledTableCell>
                            ))}
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableCell>Puan</StyledTableCell>
                            {karsilastirmaPrograms.map(program => (
                                <StyledTableCell key={`${program.programKodu}-puan`}>{program.taban.toFixed(2)}</StyledTableCell>
                            ))}
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableCell>Sıralama</StyledTableCell>
                            {karsilastirmaPrograms.map(program => (
                                <StyledTableCell key={`${program.programKodu}-siralama`}>{program.siralama.toLocaleString()}</StyledTableCell>
                            ))}
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableCell>Kontenjan</StyledTableCell>
                            {karsilastirmaPrograms.map(program => (
                                <StyledTableCell key={`${program.programKodu}-kontenjan`}>{program.kontenjan}</StyledTableCell>
                            ))}
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableCell>Doluluk</StyledTableCell>
                            {karsilastirmaPrograms.map(program => (
                                <StyledTableCell key={`${program.programKodu}-doluluk`}>
                                    <Chip
                                        label={program.doluluk}
                                        size="small"
                                        color={program.doluluk === "Doldu" ? "success" : "warning"}
                                    />
                                </StyledTableCell>
                            ))}
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableCell>Ücret</StyledTableCell>
                            {karsilastirmaPrograms.map(program => (
                                <StyledTableCell key={`${program.programKodu}-ucret`}>{program.ucret}</StyledTableCell>
                            ))}
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableCell>Öğretim Türü</StyledTableCell>
                            {karsilastirmaPrograms.map(program => (
                                <StyledTableCell key={`${program.programKodu}-ogretim`}>{program.ogretimTuru}</StyledTableCell>
                            ))}
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableCell>Program Türü</StyledTableCell>
                            {karsilastirmaPrograms.map(program => (
                                <StyledTableCell key={`${program.programKodu}-programTuru`}>{program.programTuru}</StyledTableCell>
                            ))}
                        </StyledTableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        );
    };

    return (
        <Box sx={{ px: { xs: 1, sm: 2 } }}>
            <Box sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'space-between',
                alignItems: { xs: 'flex-start', sm: 'center' },
                mb: 3
            }}>
                <Typography
                    variant="h5"
                    component="h1"
                    sx={{
                        fontWeight: 600,
                        mb: { xs: 2, sm: 0 },
                        color: theme.palette.text.primary
                    }}
                >
                    <SchoolIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                    YÖK Atlas Tercih Robotu
                </Typography>

                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Button
                        variant="outlined"
                        startIcon={showFilters ? <ExpandLessIcon /> : <FilterListIcon />}
                        onClick={() => setShowFilters(!showFilters)}
                    >
                        {showFilters ? "Filtreleri Gizle" : "Filtreleri Göster"}
                    </Button>

                    {karsilastirma.length > 0 && (
                        <Button
                            variant="outlined"
                            color="secondary"
                            startIcon={<CompareArrowsIcon />}
                            onClick={() => setShowKarsilastirma(!showKarsilastirma)}
                        >
                            Karşılaştır ({karsilastirma.length})
                        </Button>
                    )}
                </Box>
            </Box>

            {/* Karşılaştırma Tablosu */}
            <Collapse in={showKarsilastirma && karsilastirma.length > 0}>
                {renderKarsilastirmaTable()}
            </Collapse>

            {/* Filtreler */}
            <Collapse in={showFilters}>
                <FilterCard>
                    <CardContent>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6} md={3}>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Program Türü</InputLabel>
                                    <Select
                                        value={programTuru}
                                        onChange={(e) => setProgramTuru(e.target.value as 'onlisans' | 'lisans')}
                                        label="Program Türü"
                                    >
                                        <MenuItem value="onlisans">Önlisans (2 Yıllık)</MenuItem>
                                        <MenuItem value="lisans">Lisans (4 Yıllık)</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Puan Türü</InputLabel>
                                    <Select
                                        value={puanTuru}
                                        onChange={(e) => setPuanTuru(e.target.value)}
                                        label="Puan Türü"
                                    >
                                        {programTuru === 'onlisans' ? (
                                            <MenuItem value="TYT">TYT</MenuItem>
                                        ) : (
                                            <>
                                                <MenuItem value="SAY">Sayısal</MenuItem>
                                                <MenuItem value="EA">Eşit Ağırlık</MenuItem>
                                                <MenuItem value="SOZ">Sözel</MenuItem>
                                                <MenuItem value="DIL">Dil</MenuItem>
                                            </>
                                        )}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                                <Autocomplete
                                    multiple
                                    size="small"
                                    options={universiteler}
                                    value={selectedUniversiteler}
                                    onChange={(_, newValue) => setSelectedUniversiteler(newValue)}
                                    renderInput={(params) => <TextField {...params} label="Üniversite" />}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                                <Autocomplete
                                    multiple
                                    size="small"
                                    options={onlisansProgramlari}
                                    value={selectedProgramlar}
                                    onChange={(_, newValue) => setSelectedProgramlar(newValue)}
                                    renderInput={(params) => <TextField {...params} label="Program" />}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                                <Autocomplete
                                    multiple
                                    size="small"
                                    options={turkiyeSehirleri}
                                    value={selectedSehirler}
                                    onChange={(_, newValue) => setSelectedSehirler(newValue)}
                                    renderInput={(params) => <TextField {...params} label="Şehirler" />}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Üniversite Türü</InputLabel>
                                    <Select
                                        multiple
                                        value={universiteTuru}
                                        onChange={(e) => setUniversiteTuru(e.target.value as ('devlet' | 'vakif' | 'kktc' | 'yurtdisi')[])}
                                        label="Üniversite Türü"
                                        renderValue={(selected) => (
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                {selected.map((value) => (
                                                    <Chip
                                                        key={value}
                                                        label={
                                                            value === 'devlet' ? 'Devlet' :
                                                                value === 'vakif' ? 'Vakıf' :
                                                                    value === 'kktc' ? 'KKTC' : 'Yurt Dışı'
                                                        }
                                                        size="small"
                                                    />
                                                ))}
                                            </Box>
                                        )}
                                    >
                                        <MenuItem value="devlet">Devlet</MenuItem>
                                        <MenuItem value="vakif">Vakıf</MenuItem>
                                        <MenuItem value="kktc">KKTC</MenuItem>
                                        <MenuItem value="yurtdisi">Yurt Dışı</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Ücret/Burs</InputLabel>
                                    <Select
                                        multiple
                                        value={ucretBurs}
                                        onChange={(e) => setUcretBurs(e.target.value as ('ucretsiz' | 'ucretli' | 'io-ucretli' | 'burslu' | 'indirimli25' | 'indirimli50' | 'ao-ucretli' | 'uo-ucretli')[])}
                                        label="Ücret/Burs"
                                        renderValue={(selected) => (
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                {selected.map((value) => (
                                                    <Chip
                                                        key={value}
                                                        label={
                                                            value === 'ucretsiz' ? 'Ücretsiz' :
                                                                value === 'ucretli' ? 'Ücretli' :
                                                                    value === 'io-ucretli' ? 'İÖ-Ücretli' :
                                                                        value === 'burslu' ? 'Burslu' :
                                                                            value === 'indirimli25' ? '%25 İndirimli' :
                                                                                value === 'indirimli50' ? '%50 İndirimli' :
                                                                                    value === 'ao-ucretli' ? 'AÖ-Ücretli' : 'UÖ-Ücretli'
                                                        }
                                                        size="small"
                                                    />
                                                ))}
                                            </Box>
                                        )}
                                    >
                                        <MenuItem value="ucretsiz">Ücretsiz</MenuItem>
                                        <MenuItem value="ucretli">Ücretli</MenuItem>
                                        <MenuItem value="io-ucretli">İÖ-Ücretli</MenuItem>
                                        <MenuItem value="burslu">Burslu</MenuItem>
                                        <MenuItem value="indirimli25">%25 İndirimli</MenuItem>
                                        <MenuItem value="indirimli50">%50 İndirimli</MenuItem>
                                        <MenuItem value="ao-ucretli">AÖ-Ücretli</MenuItem>
                                        <MenuItem value="uo-ucretli">UÖ-Ücretli</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Öğretim Türü</InputLabel>
                                    <Select
                                        multiple
                                        value={ogretimTuru}
                                        onChange={(e) => setOgretimTuru(e.target.value as ('orgun' | 'ikinci' | 'acik' | 'uzaktan')[])}
                                        label="Öğretim Türü"
                                        renderValue={(selected) => (
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                {selected.map((value) => (
                                                    <Chip
                                                        key={value}
                                                        label={
                                                            value === 'orgun' ? 'Örgün' :
                                                                value === 'ikinci' ? 'İkinci Öğretim' :
                                                                    value === 'acik' ? 'Açıköğretim' : 'Uzaktan'
                                                        }
                                                        size="small"
                                                    />
                                                ))}
                                            </Box>
                                        )}
                                    >
                                        <MenuItem value="orgun">Örgün</MenuItem>
                                        <MenuItem value="ikinci">İkinci Öğretim</MenuItem>
                                        <MenuItem value="acik">Açıköğretim</MenuItem>
                                        <MenuItem value="uzaktan">Uzaktan</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Program Kodu"
                                    value={programKodu}
                                    onChange={(e) => setProgramKodu(e.target.value)}
                                    placeholder="Örn: 103490526"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <Typography gutterBottom>Puan Aralığı</Typography>
                                <Slider
                                    value={puanAraligi}
                                    onChange={(_, newValue) => setPuanAraligi(newValue as [number, number])}
                                    valueLabelDisplay="auto"
                                    min={150}
                                    max={500}
                                    step={1}
                                />
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography variant="body2" color="text.secondary">{puanAraligi[0]}</Typography>
                                    <Typography variant="body2" color="text.secondary">{puanAraligi[1]}</Typography>
                                </Box>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <FormControl component="fieldset">
                                    <Typography gutterBottom>Doluluk Durumu</Typography>
                                    <Box sx={{ display: 'flex', gap: 2 }}>
                                        <Button
                                            variant={dolulukDurumu === true ? "contained" : "outlined"}
                                            color="primary"
                                            onClick={() => setDolulukDurumu(dolulukDurumu === true ? null : true)}
                                            startIcon={<CheckCircleIcon />}
                                            size="small"
                                        >
                                            Doldu
                                        </Button>
                                        <Button
                                            variant={dolulukDurumu === false ? "contained" : "outlined"}
                                            color="warning"
                                            onClick={() => setDolulukDurumu(dolulukDurumu === false ? null : false)}
                                            startIcon={<CancelIcon />}
                                            size="small"
                                        >
                                            Dolmadı
                                        </Button>
                                        {dolulukDurumu !== null && (
                                            <Button
                                                variant="outlined"
                                                color="inherit"
                                                onClick={() => setDolulukDurumu(null)}
                                                startIcon={<ClearIcon />}
                                                size="small"
                                            >
                                                Temizle
                                            </Button>
                                        )}
                                    </Box>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        startIcon={<ClearIcon />}
                                        onClick={resetFilters}
                                    >
                                        Filtreleri Temizle
                                    </Button>

                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={sadeceFavoriler}
                                                    onChange={(e) => setSadeceFavoriler(e.target.checked)}
                                                    color="primary"
                                                />
                                            }
                                            label="Sadece Favoriler"
                                        />

                                        <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<SearchIcon />}
                                            onClick={() => refetch()}
                                        >
                                            Programları Getir
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </CardContent>
                </FilterCard>
            </Collapse>

            {/* Sonuçlar */}
            {isLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                    <CircularProgress />
                </Box>
            ) : error ? (
                <Alert
                    severity="error"
                    variant="filled"
                    sx={{
                        mt: 2,
                        borderRadius: theme.shape.borderRadius * 1.5,
                        boxShadow: theme.shadows[3]
                    }}
                >
                    {(error as Error).message}
                </Alert>
            ) : filteredPrograms.length === 0 ? (
                <Alert
                    severity="info"
                    variant="outlined"
                    icon={<FilterAltIcon />}
                    sx={{
                        mt: 2,
                        borderRadius: theme.shape.borderRadius * 1.5,
                        boxShadow: theme.shadows[1],
                        bgcolor: theme.palette.background.paper
                    }}
                >
                    <Typography variant="body1">
                        Seçilen kriterlere uygun program bulunamadı. Lütfen filtrelerinizi değiştirin.
                    </Typography>
                </Alert>
            ) : (
                <>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="body2" color="text.secondary">
                            Toplam {data?.recordsFiltered} program bulundu.
                        </Typography>

                        <FormControl size="small" sx={{ minWidth: 150 }}>
                            <InputLabel>Sayfa Başı</InputLabel>
                            <Select
                                value={limit.toString()}
                                onChange={(e) => {
                                    setLimit(parseInt(e.target.value));
                                    setPage(0);
                                }}
                                label="Sayfa Başı"
                            >
                                <MenuItem value="10">10</MenuItem>
                                <MenuItem value="20">20</MenuItem>
                                <MenuItem value="50">50</MenuItem>
                                <MenuItem value="100">100</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>

                    <Box sx={{ mt: { xs: 2, sm: 3 } }}>
                        {isTablet ? (
                            <Grid container spacing={2}>
                                {filteredPrograms.map(program => renderProgramCard(program))}
                            </Grid>
                        ) : (
                            renderProgramTable()
                        )}
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                        <Pagination
                            count={Math.ceil((data ? data.recordsFiltered : 0) / limit)}
                            page={page + 1}
                            onChange={(_, value) => setPage(value - 1)}
                            color="primary"
                            showFirstButton
                            showLastButton
                        />
                    </Box>
                </>
            )}

            <Box sx={{ mt: 4, p: 2, bgcolor: 'rgba(0, 0, 0, 0.03)', borderRadius: 2 }}>
                <Typography variant="caption" color="text.secondary" align="center" display="block">
                    Bilgiler YÖK Atlas'tan alınmıştır. Nihai kontrollerinizi ÖSYM'nin internet sitesindeki
                    Yükseköğretim Programları ve Kontenjanları Kılavuzu'ndan yapmanız önerilir.
                </Typography>
            </Box>
        </Box>
    );
};

export default TercihRobotu;